import {
	AppBar, Box, Divider, ToggleButton,
	//Typography
} from "@mui/material"
import Toolbar from "@mui/material/Toolbar"
import {
	FormatBold,
	FormatItalic,
	FormatListBulleted,
	FormatListNumbered,
	StrikethroughS,
	Image,
} from "@mui/icons-material"
import {HeadingMenu} from "./HeadingMenu"
import {useEffect, useRef, useState} from "react"
import {useCurrentEditor, useEditorState} from "@tiptap/react"
import {ProviderStatusIndicator} from "./ProviderStatusIndicator"
import {HighlightMenu} from "./HighlightColorMenu"
import {FontSizeMenu} from "./FontSizeMenu"


function EditorMenuIcon ({isActiveCondition, toggleAction, children}) {
	return (
		<ToggleButton
			value={"na"}
			selected={isActiveCondition}
			className={isActiveCondition ? "Mui-selected" : ""}
			onChange={toggleAction}
		>
			{children}
		</ToggleButton>
	)
}

export function MenuBar({isSynching, connectionError, lastUpdated}) {
	const timer = useRef()
	const [showIsSynching, setShowIsSynching] = useState(false)

	const {editor} = useCurrentEditor()

	const editorState = useEditorState({
		editor,
		// This function will be called every time the editor state changes
		selector: ({ editor }) => ({
			// It will only re-render if the bold or italic state changes
			isBold: editor.isActive("bold"),
			isItalic: editor.isActive("italic"),
			isStrikethrough: editor.isActive("strike"),
			isBulletList: editor.isActive("bulletList"),
			isOrderedList: editor.isActive("orderedList"),
			isHeading: editor.isActive("heading"),
			isImage: editor.isActive("imageResize"),
			isHighlightColor: editor.isActive("highlight"),
			currentHighlightColor: editor.getAttributes("highlight").color,
			currentFontSize: editor.getAttributes("textStyle").fontSize,
		}),
	})

	useEffect(() => {
		if(isSynching) {
			setShowIsSynching(true)
			timer.current = setTimeout(() => {
				setShowIsSynching(false)
			}, 1500)
		}
	}, [isSynching])

	if(!editor) return null
	return (
		<AppBar
			position="sticky"
			sx={{
				flexDirection: "row",
			}}
		>
			<Toolbar sx={{ width: "75vw", margin: "0 auto", }}>

				<Box className={"doc-toolbar"}>

					{/* Text Formatting */}

					<EditorMenuIcon
						isActiveCondition={editorState.isBold}
						toggleAction={() => editor.chain().focus().toggleBold().run()}
					>
						<FormatBold/>
					</EditorMenuIcon>
					<EditorMenuIcon
						isActiveCondition={editorState.isItalic}
						toggleAction={() => editor.chain().focus().toggleItalic().run()}
					>
						<FormatItalic/>
					</EditorMenuIcon>
					<EditorMenuIcon
						isActiveCondition={editorState.isStrikethrough}
						toggleAction={() => editor.chain().focus().toggleStrike().run()}
					>
						<StrikethroughS />
					</EditorMenuIcon>

					{/* List Types */}

					<Divider
						flexItem
						orientation={"vertical"}
						variant={"middle"}
					/>
					<EditorMenuIcon
						isActiveCondition={editorState.isBulletList}
						toggleAction={() => editor.chain().focus().toggleBulletList().run()}
					>
						<FormatListBulleted />
					</EditorMenuIcon>
					<EditorMenuIcon
						isActiveCondition={editorState.isOrderedList}
						toggleAction={() => editor.chain().focus().toggleOrderedList().run()}
					>
						<FormatListNumbered />
					</EditorMenuIcon>
					<Divider
						flexItem
						orientation={"vertical"}
						variant={"middle"}
					/>

					{/* Text Styles With Dropdown menus */}

					<HeadingMenu
						editor={editor}
						editorState={editorState}
					/>
					<HighlightMenu
						editor={editor}
						editorState={editorState}
					/>
					<FontSizeMenu
						editor={editor}
						editorState={editorState}
					/>
					<Divider
						flexItem
						orientation={"vertical"}
						variant={"middle"}
					/>
					<EditorMenuIcon
						isActiveCondition={editorState.isImage}
					>
						<Image />
					</EditorMenuIcon>
				</Box>
				<ProviderStatusIndicator
					isLoading={showIsSynching}
					connectionError={connectionError}
					lastUpdated={lastUpdated}
				/>
			</Toolbar>
		</AppBar>
	)
}